import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateSubjectForm from "../../forms/CreateOrUpdateSubjectForm";
import { SubjectResponseDto } from "../../shared/dtos/subject/SubjectResponseDto";

interface UpdateSubjectModalProps {
  open: boolean;
  onClose: () => void;
  subject: SubjectResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateSubjectModal: React.FC<UpdateSubjectModalProps> = ({
  open,
  onClose,
  subject,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Subject: ${subject.name}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateSubjectForm
      isEditing={true}
      subject={subject}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateSubjectModal;
